import {
  NavbarExpandableMenu,
  NavbarExpandableMenuContent,
  NavbarExpandableMenuTrigger
} from "./chunk-DRSAVDIE.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/navbar/navbar.tsx
import { forwardRef } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { Slot } from "@radix-ui/react-slot";
import { jsx } from "react/jsx-runtime";
var NavbarLogo = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, className, asChild } = _b, rest = __objRest(_b, ["children", "className", "asChild"]);
    const Component = asChild ? Slot : "div";
    return /* @__PURE__ */ jsx(Component, __spreadProps(__spreadValues({ className: clsx(`hds-navbar__logo`, className), ref }, rest), { children }));
  }
);
NavbarLogo.displayName = "Navbar.Logo";
var NavbarLogoAndServiceText = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, asChild, variant, className } = _b, rest = __objRest(_b, ["children", "asChild", "variant", "className"]);
    const Component = asChild ? Slot : "div";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadProps(__spreadValues({
        ref,
        className: clsx(
          "hds-navbar__logo-and-service-text",
          `hds-navbar__logo-and-service-text--${variant}`,
          className
        )
      }, rest), {
        children
      })
    );
  }
);
NavbarLogoAndServiceText.displayName = "Navbar.NavbarLogoAndText";
var NavbarItemIcon = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
    return /* @__PURE__ */ jsx(Slot, __spreadProps(__spreadValues({ className: clsx("hds-navbar__item-icon", className), ref }, rest), { children }));
  }
);
NavbarItemIcon.displayName = "Navbar.ItemIcon";
var NavbarItem = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, children, className } = _b, rest = __objRest(_b, ["asChild", "children", "className"]);
    const Component = asChild ? Slot : "div";
    return /* @__PURE__ */ jsx(Component, __spreadProps(__spreadValues({ className: clsx("hds-navbar__item", className), ref }, rest), { children }));
  }
);
NavbarItem.displayName = "Navbar.Item";
var NavbarButtonItem = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, children, className } = _b, rest = __objRest(_b, ["asChild", "children", "className"]);
    const Component = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadProps(__spreadValues({
        className: clsx("hds-navbar__item", className),
        ref,
        type: "button"
      }, rest), {
        children
      })
    );
  }
);
NavbarButtonItem.displayName = "Navbar.ButtonItem";
var NavbarLinkItem = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, children, className } = _b, rest = __objRest(_b, ["asChild", "children", "className"]);
    const Component = asChild ? Slot : "a";
    return /* @__PURE__ */ jsx(Component, __spreadProps(__spreadValues({ className: clsx("hds-navbar__item", className), ref }, rest), { children }));
  }
);
NavbarLinkItem.displayName = "Navbar.LinkItem";
var NavbarNavigation = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, className } = _b, rest = __objRest(_b, ["asChild", "className"]);
    const Component = asChild ? Slot : "div";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadValues({
        className: clsx("hds-navbar__navigation", className),
        ref
      }, rest)
    );
  }
);
NavbarNavigation.displayName = "Navbar.Navigation";
var Navbar = forwardRef(
  (_a, ref) => {
    var _b = _a, { asChild, children, className, variant } = _b, rest = __objRest(_b, ["asChild", "children", "className", "variant"]);
    const Component = asChild ? Slot : "header";
    return /* @__PURE__ */ jsx(
      Component,
      __spreadProps(__spreadValues({
        className: clsx("hds-navbar", variant && `hds-navbar--${variant}`, className),
        ref
      }, rest), {
        children
      })
    );
  }
);
Navbar.displayName = "Navbar";
Navbar.Logo = NavbarLogo;
Navbar.LogoAndServiceText = NavbarLogoAndServiceText;
Navbar.ExpandableMenu = NavbarExpandableMenu;
Navbar.ExpandableMenuTrigger = NavbarExpandableMenuTrigger;
Navbar.ExpandableMenuContent = NavbarExpandableMenuContent;
Navbar.Item = NavbarItem;
Navbar.ButtonItem = NavbarButtonItem;
Navbar.LinkItem = NavbarLinkItem;
Navbar.ItemIcon = NavbarItemIcon;
Navbar.Navigation = NavbarNavigation;

export {
  NavbarLogo,
  NavbarLogoAndServiceText,
  NavbarItemIcon,
  NavbarItem,
  NavbarButtonItem,
  NavbarLinkItem,
  NavbarNavigation,
  Navbar
};
//# sourceMappingURL=chunk-DTU7AXY3.mjs.map